import { FC } from "react"
import { graphql } from "gatsby"
import { IGatsbyImageData } from "gatsby-plugin-image"
// ** Custom Components
import Box from "../components/Box"
import Layout from "../components/Layout"
import { SEO } from "../components/SEO"

// ** Sections
import SectionHero from "../sections/blog/SectionBlogHero"
import SectionKnowledgeHub from "../sections/blog/SectionKnowledgeHub"
import Pagination from "../components/Pagination/intex"
import PageContext from "../contexts/PageContext"

// ** Helpers
import { parseLink } from "../utils/helpers"

type cardType = {
  title: string
  type: string
  image: IGatsbyImageData
  link: string
}

const Posts: FC<any> = (props) => {
  const lang = props?.pageContext?.lang
  const i18n = props?.pageContext?.i18n
  const allSanityPost = props?.data?.allSanityPost
  const topics = props?.pageContext?.topics
  const currentTopic = props?.pageContext?.currentTopic
  let cards: cardType[] = []
  /// pagination
  const { currentPage, numPages } = props.pageContext
  const prefix = props?.pageContext?.prefix
  allSanityPost?.nodes?.map((card: any) => {
    const section = card?.sections?.find(
      (section: any) => section?.label && section
    )
    cards = [
      ...cards,
      {
        title: card.title,
        type: card.tags[0],
        image: section?.media?.image_mobile?.asset?.gatsbyImageData,
        link: parseLink(section?.linkPrimary),
      },
    ]
  })
  return (
    <PageContext.Provider value={i18n}>
      <Layout>
        <Box
          as="main"
          className="min-h-screen flex flex-col gap-12 lg:gap-16 pt-14 md:pt-24"
        >
          <SectionHero lang={lang} />
          <SectionKnowledgeHub
            cards={cards}
            topics={topics}
            currentTopic={currentTopic}
            lang={lang}
          />
          <Pagination
            currentPage={currentPage}
            numPages={numPages}
            prefix={prefix}
          />
        </Box>
      </Layout>
    </PageContext.Provider>
  )
}
export const postsQuery = graphql`
  query ($skip: Int!, $limit: Int!, $paths: [String!]!) {
    allSanityPost(
      filter: { slug: { current: { in: $paths } } }
      limit: $limit
      skip: $skip
      sort: { fields: _createdAt, order: DESC }
    ) {
      nodes {
        id
        title
        tags
        slug {
          current
        }
        seoTitle
        seoDescription
        sections {
          ... on SanitySectionContent {
            id
            label
            media {
              image_mobile {
                asset {
                  gatsbyImageData(
                    layout: CONSTRAINED
                    sizes: "300"
                    width: 300
                    formats: [AUTO, WEBP]
                    placeholder: NONE
                  )
                }
              }
            }
            linkPrimary {
              ... on SanityLinkInternal {
                id
                title
                path
                reference {
                  slug {
                    current
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
export default Posts

export const Head = () => <SEO title="8Twelve Mortgage - Blogs" />
